import { isPlatformServer } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { loadScript } from '../lib/load-script';
import { StateService } from './state.service';

@Injectable({
  providedIn: 'root',
})
export class TenantGoogleTagmanagerService {
  private platformId = inject(PLATFORM_ID);
  private state = inject(StateService);
  loaded = false;

  public load(gtmId: string): void {
    if (isPlatformServer(this.platformId)) return;
    const email = this.state.user?.email;
    if (this.state.impersonating) return;
    if (email && ['@nusign.com', '@picflow.com'].find(_email => email.endsWith(_email))) return;
    if (this.loaded) return;
    this.loaded = true;
    // We are assuming that the analytics service sets up the dataLayer object
    loadScript(`https://measure.picflow.com/gtm.js?id=${gtmId}`);
  }
}
